"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgTablet(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("rect", { x: 3.5, y: 33.5, width: 26, height: 34, rx: 2.016, transform: "rotate(-90 3.5 33.5)", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.5 20.453c0-1.131-.895-2.048-2-2.048s-2 .917-2 2.048c0 1.13.895 2.047 2 2.047s2-.917 2-2.047z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgTablet;
//# sourceMappingURL=Tablet.js.map